import React from 'react';
import cx from 'classnames';
import { RegionReportItemsLabel } from './RegionReportItemsLabel';
import styles from '../RegionReport.css';
import { toDateString } from '../../../../utils/date';
import { ApplicationStats } from '../../../../types';

export type ApplicationStatsLabelProps = {
  allowHover?: boolean;
  dataTestId: string;
  item: ApplicationStats;
  locale: string;
  showIcon: boolean;
  index: number;
  cropCode: string;
  cropNominalWeight?: number;
};

export const ApplicationStatsLabel = ({
  allowHover = false,
  dataTestId,
  item,
  locale,
  showIcon = false, // change default prop when L2 application UI is ready
  index,
  cropCode,
  cropNominalWeight
}: ApplicationStatsLabelProps) => {
  const { averageYield, area, dateApplied = '' } = item;
  return (
    <div
      className={cx(styles.content, { [styles.contentRow]: allowHover })}
      data-test-id={`dmb-region-report-${dataTestId}-stats-label`}
      key={`dmb-region-report-item-${item.label}`}
    // add onClick for L2 screen here
    >
      <div className={styles.first}>
        <div data-test-id={`dmb-region-report-${dataTestId}-label`}>
          {item.label}
          <div className={styles.date} data-test-id={`dmb-region-report-${dataTestId}-date`}>
            {toDateString(dateApplied, locale)}
          </div>
        </div>
      </div>
      <RegionReportItemsLabel 
        area={area} 
        averageYield={averageYield} 
        dataTestId={dataTestId} 
        showIcon={showIcon} 
        index={index}
        cropCode={cropCode}
        cropNominalWeight={cropNominalWeight}
      />
    </div>
  );
};